import { fetchNotices } from "./../features/notice/noticesSlice";
import axios from "axios";
import { GURL } from "./global";

export const GetGroups = () => {
	axios.defaults.headers.common[
		"Authorization"
	] = `Bearer ${localStorage.getItem("token")}`;
	return axios.get(`${GURL}/Messaging/v1/Groups/GetGroups`);
};
export const CreateGroup = (f: any) => {
	axios.defaults.headers.common[
		"Authorization"
	] = `Bearer ${localStorage.getItem("token")}`;
	return axios.post(`${GURL}/Messaging/v1/Groups`, f);
};
